import React from 'react';
import './style.scss';

type Props = {
	text: string;
	shadow: boolean;
	loading?: boolean;
};

const ButtonPrimary: React.FC<Props> = ({text, shadow = false, loading = false}) => (
	<div className='buttons'>
		<button className={`buttons ${shadow ? 'buttons__boxShadow button is-light' : 'button is-light'}`} disabled={loading}>{text}</button>
	</div>
);

export default ButtonPrimary;
